import * as React from 'react';
import { useTranslation } from 'react-i18next';
const FormError = props => {
  const {
    t
  } = useTranslation();
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement("span", {
    "aria-live": "polite",
    className: "form-error"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, t('form.error.message_prefix'), ":"), children);
};
export default FormError;